import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"background-color":"var(--color-light-light-gray)","padding":"20px","margin-bottom":"40px","border-radius":"4px","box-shadow":"0 1px 3px rgba(0, 0, 0, 0.1)"}
}
const _hoisted_2 = { class: "h5 fw-bold mb-3" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "d-flex justify-content-center" }
const _hoisted_6 = {
  class: "d-flex align-items-end",
  style: {"height":"220px","width":"100%"}
}
const _hoisted_7 = { class: "d-flex justify-content-around w-100" }
const _hoisted_8 = { class: "d-flex flex-column align-items-center" }
const _hoisted_9 = {
  style: {"width":"120px","height":"180px"},
  class: "position-relative"
}
const _hoisted_10 = {
  class: "text-white small fw-bold d-flex align-items-center justify-content-center",
  style: { height: '100%' }
}
const _hoisted_11 = { class: "fw-bold mt-2" }
const _hoisted_12 = {
  class: "small",
  style: {"font-size":"12px"}
}
const _hoisted_13 = { class: "d-flex flex-column align-items-center" }
const _hoisted_14 = {
  style: {"width":"120px","height":"180px"},
  class: "position-relative"
}
const _hoisted_15 = {
  class: "text-white small fw-bold d-flex align-items-center justify-content-center",
  style: { height: '100%' }
}
const _hoisted_16 = {
  class: "text-dark small fw-bold d-flex align-items-center justify-content-center",
  style: { height: '100%' }
}
const _hoisted_17 = { class: "fw-bold mt-2" }
const _hoisted_18 = {
  class: "small",
  style: {"font-size":"12px"}
}
const _hoisted_19 = { class: "mt-4" }
const _hoisted_20 = { class: "d-flex justify-content-center" }
const _hoisted_21 = {
  class: "me-4",
  style: {"font-size":"12px"}
}
const _hoisted_22 = {
  key: 0,
  class: "badge me-2",
  style: {"background-color":"var(--color-graph-green)","border-radius":"50%","width":"16px","height":"16px"}
}
const _hoisted_23 = {
  key: 1,
  class: "me-4",
  style: {"font-size":"12px"}
}
const _hoisted_24 = { style: {"font-size":"12px"} }
const _hoisted_25 = { class: "mt-3" }
const _hoisted_26 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.includeSections.installments && _ctx.paymentType === 'installment')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t("project.previewAndReport.installments.monthlyCoverage.title")), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", {
                        class: "w-100 position-absolute bottom-0",
                        style: _normalizeStyle([{"background-color":"var(--color-red)"}, {
                      height: _ctx.getPaymentBarHeight(),
                      borderRadius: '2px 2px 0 0',
                    }])
                      }, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.formatCurrency(
                          _ctx.projectData?.financial_data?.installment_amount || 0
                        )), 1)
                      ], 4)
                    ]),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t(
                      "project.previewAndReport.installments.monthlyCoverage.monthlyPayment"
                    )), 1),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.formatCurrency(
                      _ctx.projectData?.financial_data?.installment_amount || 0
                    )), 1)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", {
                        class: "w-100 position-absolute",
                        style: _normalizeStyle([{"background-color":"var(--color-green)"}, {
                      bottom: _ctx.getMonthlyCashbackHeight(),
                      height: _ctx.getMonthlyEnergyHeight(),
                      borderRadius: '2px 2px 0 0',
                    }])
                      }, [
                        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.formatCurrency(
                          (_ctx.projectData?.financial_data?.annual_revenue || 0) /
                            12
                        )), 1)
                      ], 4),
                      (_ctx.shouldShowCashback())
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "w-100 position-absolute bottom-0",
                            style: _normalizeStyle([{"background-color":"var(--color-graph-green)"}, {
                      height: _ctx.getMonthlyCashbackHeight(),
                      borderRadius: '0 0 2px 2px',
                    }])
                          }, [
                            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.formatCurrency(
                          (_ctx.projectData?.financial_data?.cashback_amount || 0) / 120
                        )), 1)
                          ], 4))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t(
                      "project.previewAndReport.installments.monthlyCoverage.monthlySaving"
                    )), 1),
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.formatCurrency(
                      (_ctx.projectData?.financial_data?.annual_revenue || 0) / 12 +
                      (_ctx.shouldShowCashback() ? (_ctx.projectData?.financial_data?.cashback_amount || 0) / 120 : 0)
                    )), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _cache[0] || (_cache[0] = _createElementVNode("div", {
                  class: "badge me-2",
                  style: {"background-color":"var(--color-red)","border-radius":"50%","width":"16px","height":"16px"}
                }, "   ", -1)),
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t(
                  "project.previewAndReport.installments.monthlyCoverage.monthlyPayment"
                )), 1),
                (_ctx.shouldShowCashback())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, "   "))
                  : _createCommentVNode("", true),
                (_ctx.shouldShowCashback())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.$t(
                  "project.previewAndReport.installments.monthlyCoverage.cashback"
                )), 1))
                  : _createCommentVNode("", true),
                _cache[1] || (_cache[1] = _createElementVNode("div", {
                  class: "badge me-2",
                  style: {"background-color":"var(--color-green)","border-radius":"50%","width":"16px","height":"16px"}
                }, "   ", -1)),
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t(
                  "project.previewAndReport.installments.monthlyCoverage.energyProduction"
                )), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("p", {
            class: "mb-0",
            style: {"font-size":"12px"},
            innerHTML: _ctx.$t('project.previewAndReport.cashFlow.description')
          }, null, 8, _hoisted_26)
        ])
      ]))
    : _createCommentVNode("", true)
}